import { render, staticRenderFns } from "./OccurrenceTree.vue?vue&type=template&id=b02879e2&scoped=true&"
import script from "./OccurrenceTree.vue?vue&type=script&lang=js&"
export * from "./OccurrenceTree.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceTree.vue?vue&type=style&index=0&id=b02879e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02879e2",
  null
  
)

export default component.exports